import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { ListingService } from '../../../services/listing.service';
import { firstValueFrom } from 'rxjs';

import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-category-wise-products',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './category-wise-products.component.html',
  styleUrls: ['./category-wise-products.component.css'],
})
export class CategoryWiseProductsComponent implements OnInit {

  products: any[] = [];
  visibleCount = 3;
  categoryName = '';
  loading = false;

  constructor(
    private route: ActivatedRoute,
    private listingService: ListingService
  ) { }

  ngOnInit() {
    this.categoryName = this.route.snapshot.paramMap.get('category') || '';
    this.fetchProducts();
  }

  async fetchProducts() {
    this.loading = true;
    try {
      const result = await firstValueFrom(this.listingService.list());
      const allProducts = result.records || [];

      this.products = allProducts.filter((p: any) =>
        p.category?.toLowerCase() === this.categoryName.toLowerCase()
      );
    } catch (error) {
      console.error('Error fetching products:', error);
    } finally {
      this.loading = false;
    }
  }

  seeMore() {
    this.visibleCount += 2;
  }
}
